/**
 * Unsigned whole numbers only: strips non-digits and drops any fractional part
 * (only the segment before the first "." or "," is kept).
 */
export function sanitizeUnsignedIntegerString(raw) {
  if (raw == null || raw === "") return "";
  const beforeSep = String(raw).split(/[.,]/)[0];
  return beforeSep.replace(/\D/g, "");
}

/** Block typing/pasting characters that are not digits (allows control keys, arrows, Tab, etc.). */
export function blockUnsignedIntegerKeyDown(e) {
  if (e.defaultPrevented) return;
  if (e.ctrlKey || e.metaKey || e.altKey) return;
  if (
    e.key === "Backspace" ||
    e.key === "Delete" ||
    e.key === "Tab" ||
    e.key === "Escape" ||
    e.key === "Enter"
  ) {
    return;
  }
  if (e.key.length > 1) return;
  if (!/[0-9]/.test(e.key)) {
    e.preventDefault();
  }
}
